// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0044fde7","239":"4b36e8c7","453":"2380698d","455":"fe9a7dac"}[chunkId] + ".chunk.js";
};